module.exports = __webpack_public_path__ + "static/media/pace.1918683d.jpg";